import React, { useState } from 'react'
import { FormControl, Grid, IconButton, InputLabel, MenuItem, Select } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'

import { FilterProps } from './types'

export const createEnumFilter = (Enum: object) => {
  const EnumFilter = (props: FilterProps) => {
    const { label, defaultValue, onChange } = props
    const [selections, setSelections] = useState<any[]>(defaultValue || [])

    return (
      <Grid container>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel id={label}>{label}</InputLabel>
            <Select
              id={label}
              label={label}
              onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                const newValueList = [...selections, event.target.value]
                setSelections(newValueList)
                onChange(newValueList, newValueList.join(','))
              }}
              value={selections}
            >
              {Object.entries(Enum).map(([key, value]) => (
                <MenuItem key={key} value={key}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            {selections?.map((obj: any) => {
              if (obj) {
                return (
                  <React.Fragment key={obj.guid}>
                    <Grid item>{obj}</Grid>
                    <Grid item>
                      <IconButton
                        color="primary"
                        onClick={() => {
                          const newValueList = selections.filter((v: any) => v !== obj)
                          setSelections(newValueList)
                          onChange(newValueList, newValueList.join(','))
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Grid>
                  </React.Fragment>
                )
              }
            })}
          </Grid>
        </Grid>
      </Grid>
    )
  }
  return EnumFilter
}
